<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="searchform"
                   :model="searchform"
                   label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="名称">
                  <el-input v-model="searchform.name"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="管理员">
                  <el-input v-model="searchform.managers"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="商家">
                  <el-input v-model="searchform.ptnCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户">
                  <el-input v-model="searchform.roleUsers"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>

              <el-col :span="6">
                <el-form-item>

                  <el-button @click="dialogFormVisible = true"
                             size="medium"
                             type="success"
                             icon="el-icon-plus"></el-button>
                  <el-button type="info"
                             @click="onSubmit"
                             size="medium"
                             icon="el-icon-search"></el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row></el-row>
          </el-form>
        </el-card>

        <!-- 新增角色 -->
        <el-dialog title="角色"
                   v-if="dialogFormVisible"
                   :visible.sync="dialogFormVisible"
                   width="50%"
                   @close="addDilogClosed">
          <el-form :model="addform"
                   :label-position="labelPosition"
                   :rules="rules"
                   ref="addformRef"
                   size="mini">
            <el-form-item label="名称(英)"
                          prop="name"
                          :label-width="formLabelWidth">
              <el-input v-model="addform.name"
                        autocomplete="off"
                        style="width:70%"></el-input>
            </el-form-item>
            <el-form-item label="名称"
                          prop="nameCN"
                          :label-width="formLabelWidth">
              <el-input v-model="addform.nameCN"
                        autocomplete="off"
                        style="width:70%"></el-input>
            </el-form-item>
            <el-form-item label="类型"
                          prop="type"
                          :label-width="formLabelWidth">
              <el-select v-model="addform.type"
                         filterable
                         placeholder="请选择"
                         style="width:70%">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">{{item.label}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商家"
                          prop="ptnCode"
                          :label-width="formLabelWidth">
              <el-select v-model="addform.ptnCode"
                         placeholder="请选择商家"
                         style="width:70%"
                         @change="changPartner">
                <el-option v-for="item in PartnerLists"
                           :key="item.id"
                           :label="item.ptnName"
                           :value="item.ptnCode"></el-option>
              </el-select>
            </el-form-item>
            <el-tabs v-model="activeName"
                     @tab-click="handleClick">

              <el-tab-pane label="访问权限"
                           name="first">
                <el-row class="row-box">
                  <el-tree :data="parentMenulist"
                           :props="props"
                           node-key="id"
                           empty-text="无数据"
                           show-checkbox
                           :render-after-expand="false"
                           :default-checked-keys="defaultPChecked"
                           @check-change="handleCheckChange">
                  </el-tree>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="数据权限"
                           name="second">
                <el-row class="row-box">
                  <el-tree :data="parentShoplist"
                           :props="propShops"
                           empty-text="无数据"
                           node-key="id"
                           show-checkbox
                           :render-after-expand="false"
                           :default-checked-keys="defaultDChecked"
                           @check-change="handleShopCheckChange">
                  </el-tree>
                </el-row>
              </el-tab-pane>

            </el-tabs>

            <el-form-item label="管理员"
                          prop="managers"
                          :label-width="formLabelWidth">
              <el-select v-model="addform.managers"
                         multiple
                         placeholder="管理员"
                         style="width:70%">
                <el-option v-for="user in ManagerLists"
                           :key="user.id"
                           :label="user.username"
                           :value="user.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户"
                          :label-width="formLabelWidth">
              <el-card class="add-card"
                       style="max-height:300px;overflow:auto;width:70%;">
                <template>
                  <div>
                    <el-checkbox-group v-model="addform.users"
                                       size="small">
                      <el-checkbox v-for="item in ManagerLists"
                                   :key="item.id"
                                   :label="item.id">{{ item.username }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </template>
              </el-card>
            </el-form-item>

          </el-form>
          <div slot="footer"
               class="dialog-footer"
               style="text-align:center">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="addRole">确 定</el-button>
          </div>
        </el-dialog>
      </div>

      <el-table :data="roleList"
                border
                stripe
                style="width: 100%"
                :show-overflow-tooltip=true
                height="500">
        <el-table-column type="index"
                         label="#"></el-table-column>
        <el-table-column prop="name"
                         label="角色名称"
                         show-overflow-tooltip
                         min-width="120px"></el-table-column>
        <el-table-column prop="ptnCode"
                         label="商家"></el-table-column>
        <el-table-column label="类型"
                         width="120">
          <template slot-scope="scope">
            <el-tag>{{ options[scope.row.type].label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="管理员"
                         show-overflow-tooltip
                         min-width="120px">
          <template slot-scope="scope">
            <el-tag class="tag-m"
                    v-for="manager in scope.row.role_managers"
                    :key="manager.id">{{ manager.username }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="created_at"
                         label="创建时间"
                         show-overflow-tooltip
                         min-width="140px">
          <template slot-scope="scope">
            {{
          scope.row.created_at | parseTime
          }}
          </template>

        </el-table-column>
        <el-table-column prop="created_user"
                         label="创建者"
                         width="120"></el-table-column>

        <el-table-column label="操作"
                         width="180"
                         size="small">
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-tooltip effect="dark"
                        content="编辑"
                        placement="top"
                        :enterable="false">
              <el-button type="primary"
                         icon="el-icon-edit"
                         size="mini"
                         @click="showEditDilog(scope.row)"></el-button>
            </el-tooltip>

            <!-- 删除 -->
            <el-tooltip effect="dark"
                        content="删除"
                        placement="top"
                        :enterable="false">
              <el-button type="danger"
                         icon="el-icon-delete"
                         size="mini"
                         @click="delRole(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryInfo.pagesize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      props: {
        label: 'menuTitle',
        children: 'children',
      },
      propShops: {
        label: 'pname',
        children: 'children',
      },
      defaultPChecked: [],
      defaultDChecked: [],
      count: 1,

      options: [
        {
          value: '0',
          label: 'admin',
        },
        {
          value: '1',
          label: '商家管理员',
        },
        {
          value: '2',
          label: '店铺管理员',
        },
        {
          value: '3',
          label: '系统操作员',
        },
      ],

      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1
      },
      searchform: {
        name: '',
        nameCN: '',
        type: '',
        ptnCode: '',
        permissions: '',
        managers: '',
        roleUsers: '',
      },
      addform: {
        name: '',
        nameCN: '',
        type: '',
        ptnCode: '',
        dataPerm: [],
        pathPerm: [],
        managers: [],
        users: [],
      },

      roleList: [],
      currentPage: 1,
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      users: [],
      total: 0,
      labelPosition: 'right',
      permissions: [],
      dialogFormVisible: false,
      formLabelWidth: '100px',
      PartnerLists: [], // 商家列表
      ManagerLists: [], // 管理员
      UserLists: [], // 用户列表
      activeName: 'first',
      parentMenulist: [
        {
          id: 0,
          menuTitle: '所有权限',
          menuTitleEn: 'All',
          parentId: 0,
        },
      ],
      parentShoplist: [
        {
          id: 0,
          pname: '所有店铺',
          pcode: 'All',
          parentId: 0,
        },
      ],
      rules: {
        name: [
          { required: true, message: '名称(英)不能为空', trigger: 'blur' },
          {
            min: 3,
            max: 30,
            message: '长度在 3 到 30 个字符',
            trigger: 'blur',
          },
        ],
        nameCN: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          {
            min: 3,
            max: 30,
            message: '长度在 3 到 30 个字符',
            trigger: 'blur',
          },
        ],
        permissions: [
          { required: true, message: '选择权限', trigger: 'change' },
        ],
        ptnCode: [{ required: true, message: '选择商家', trigger: 'change' }],
        type: [{ required: true, message: '选择角色类型', trigger: 'change' }],
      },
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    onSubmit() {
      console.log('submit!')
    },

    handleSizeChange(val) {
      this.queryInfo.pagesize = val

      this.getRoleLists()
    },

    handleCurrentChange(val) {
      this.queryInfo.pagenum = val

      this.getRoleLists()
    },

    // 关闭新增窗口
    addDilogClosed() {
      console.log('close')
      this.$refs.addformRef.resetFields()
      this.addform = {
        name: '',
        nameCN: '',
        type: '',
        ptnCode: '',
        dataPerm: [],
        pathPerm: [],
        managers: [],
        users: [],
      }
      this.addform.users = []
    },

    // 显示修改用户对话框
    async showEditDilog(row) {
      let copyRole = Object.assign({}, row)
      console.log(copyRole)
      this.addform = copyRole

      this.addform.pathPerm = []
      this.addform.dataPerm = []

      this.defaultPChecked = []
      this.defaultDChecked = []
      this.changPartner(this.addform.ptnCode)
      for (let i in row.permissions) {
        if (row.permissions[i].isDataPm == '1') {
          let dataPerm = [
            { name: row.permissions[i].name, id: row.permissions[i].pm_id },
          ]

          this.addform.dataPerm.push(dataPerm)

          this.defaultDChecked.push(row.permissions[i].pm_id)
        } else if (row.permissions[i].isDataPm == '0') {
          let pathPerm = [
            { name: row.permissions[i].name, id: row.permissions[i].pm_id },
          ]

          this.addform.pathPerm.push(pathPerm)
          this.defaultPChecked.push(row.permissions[i].pm_id)
        }
      }

      this.addform.managers = []

      this.addform.users = []

      for (let j in row.users) {
        this.addform.users.push(row.users[j].id)
      }

      this.dialogFormVisible = true
      // console.log(this.addform.type, this.options[this.addform.type].label)
      // this.addform.type = this.options[this.addform.type].label
    },
    // 新增角色
    addRole() {
      this.$refs.addformRef.validate(async (valid) => {
        if (!valid) return

        await this.$http
          .post('addrole', this.addform)
          .then((response) => {
            this.$message.success('添加角色成功')

            this.dialogFormVisible = false

            this.addform.pathPerm = []

            this.addform.dataPerm = []

            this.getRoleLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      })
    },

    // 编辑角色
    editRole() {
      this.$refs.editformRef.validate(async (valid) => {
        if (!valid) return
        await this.$http
          .post('editrole', this.editform)
          .then((response) => {
            this.$message.success('success')

            this.editdialogFormVisible = false

            this.getRoleLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      })
    },

    // 处理选中的数据权限
    handleShopCheckChange(data, checked, indeterminate) {
      if (checked) {
        let dataPerm = [{ name: data.pcode, id: data.id }]

        this.addform.dataPerm.push(dataPerm)
      } else {
        for (let i in this.addform.dataPerm) {
          if (this.addform.dataPerm[i][0].id == data.id) {
            this.addform.dataPerm.splice(i, 1)
          }
        }
      }
    },

    // 删除权限
    async delRole(roleid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除该角色, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)

      // 确认删除
      if (confirmResult == 'confirm') {
        await this.$http
          .delete('delRole/' + roleid)
          .then((response) => {
            this.$message.success('删除成功')

            this.currentPage = 1

            this.getRoleLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },

    handleNodeClick(data) {},
    // 获取商家列表
    async getPartnerLists() {
      await this.$http
        .post('ptnlists', {
          query: '',
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data

          this.PartnerLists = res.data.data

          this.editdialogFormVisible = false
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    // 获取角色列表
    async getRoleLists() {
      await this.$http
        .post('rolelists', this.queryInfo)
        .then((response) => {
          const res = response.data

          this.roleList = res.data
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },

    // 获取权限列表
    async getPermissions() {
      await this.$http
        .post('Permissions', {
          query: '',
          pagenum: 1,
          pagesize: 500,
        })
        .then((response) => {
          const res = response.data

          this.permissions = res.data
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },

    // 根据商家ID获取用户列表
    async getusersByPartner(ptncode) {
      await this.$http
        .post('getptnuser', { ptnCode: ptncode })
        .then((response) => {
          this.ManagerLists = response.data.data
          response.data.data.forEach((user, index) => {
            this.users.push({
              label: user.username,
              key: user.id,
              pinyin: user.username,
            })
          })
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    // 商家变更
    changPartner(query) {
      this.users = []

      if (query !== '') {
        this.getusersByPartner(query)
      }
    },

    // 处理选中的路由权限
    handleCheckChange(data, checked, indeterminate) {
      if (checked && data.menuTitleEn != null) {
        let pathData = [{ name: data.menuTitleEn, id: data.id }]
        this.addform.pathPerm.push(pathData)
      } else {
        for (let i in this.addform.pathPerm) {
          if (this.addform.pathPerm[i][0].id == data.id) {
            this.addform.pathPerm.splice(i, 1)
          }
        }
      }
    },

    // 获取所有的菜单
    async getMenuList() {
      const { data: res } = await this.$http.post('menusRole')

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

      this.menulist = JSON.parse(JSON.stringify(res.data))
      this.$set(
        this.parentMenulist[0],
        'children',
        JSON.parse(JSON.stringify(res.data))
      )
    },

    // 获取所有商家、店铺
    async getShops() {
      const { data: res } = await this.$http.post('shoptree')

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

      this.shoplist = JSON.parse(JSON.stringify(res.data))

      this.$set(
        this.parentShoplist[0],
        'children',
        JSON.parse(JSON.stringify(res.data))
      )
    },
  },
  created() {
    this.getPartnerLists()
    this.getRoleLists()
    this.getPermissions()
    this.getMenuList()
    this.getShops()
    this.getusersByPartner(window.sessionStorage.getItem('ptnCode'))
  },
}
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
.tag-m {
  margin-right: 1px;
}
.row-box {
  margin: 10px 0;
  padding: 12px;
  border-radius: 15px;
  border: 1px dashed#77a2cf;
}
</style>


// WEBPACK FOOTER //
// src/views/sys/roles/index.vue